import axios from "axios";
import { makeUseAxios } from "axios-hooks";

const API_URL =
  process.env.REACT_APP_API_URL || "https://v3-mindi-api.herokuapp.com/v1";

const getToken = () => {
  const token = window.localStorage.getItem("token") || "";
  return `Bearer ${token} `;
};

export const api = axios.create({
  baseURL: API_URL,
  headers: { authorization: getToken() },
});

// api.interceptors.response.use(
//   function (response) {
//     return response;
//   },
//   function (error) {
//     if (401 === error.response.status) {
//       window.location = "/#/login";
//     } else {
//       return Promise.reject(error);
//     }
//   }
// );

export const getStore = async () => {
  const endpoint = `${API_URL}/portal/data`;
  const res = await axios.get(endpoint, {
    headers: { authorization: getToken() },
  });
  return res.data;
};

export const saveStore = async (store) => {
  const endpoint = `${API_URL}/establishment`;
  const res = await axios.put(endpoint, store, {
    headers: { authorization: getToken() },
  });
  return res.data;
};

export const saveProduct = async (productId, productData) => {
  const endpoint = `${API_URL}/products/${productId}`;
  const res = await axios.patch(endpoint, productData, {
    headers: { authorization: getToken() },
  });
  return res.data;
};

export const saveProducts = async (products) => {
  const endpoint = `${API_URL}/products`;
  const res = await axios.patch(endpoint, products, {
    headers: { authorization: getToken() },
  });
  return res.data;
};

export const useAxios = makeUseAxios({
  axios: axios.create({
    baseURL: API_URL,
    headers: { authorization: getToken() },
  }),
});

export const useAxiosGet = (url) => {
  const res = useAxios({
    method: "GET",
    url,
  });

  const error = res[0].error;
  if (error) {
    if (!isAuthorized(error.response)) window.location = "/#/login";
  }

  const execute = (data) => {
    res[1]({ data: data });
  };

  return [res[0], execute];
};

export const useAxiosPost = (url) => {
  const res = useAxios(
    {
      method: "POST",
      url,
    },
    { manual: true }
  );

  const error = res[0].error;
  if (error) {
    if (!isAuthorized(error.response)) window.location = "/#/login";
  }

  const execute = (data) => {
    res[1]({ data: data });
  };

  return [res[0], execute];
};

const isAuthorized = (response) => {
  if (response.status === 401) return false;
  if (response.status === 403) return false;
  return true;
};
